import './CalendarIntegration.css';

const CalendarIntegration = () => {
  return (
    <section className='calendar-integration container' id='calendar-integration'>
      <div className='calendar-integration-header'>
        <p className='calendar-integration-label'>Agenda y seguimiento</p>
        <h2>
          Citas conectadas al <span className='lancaster-color'>CRM</span>
        </h2>
        <p>
          Cuando tu operación requiere agendar citas, Lancaster permite conectar Google Calendar desde el perfil del usuario. Esa conexión se usa para revisar disponibilidad y mantener las citas sincronizadas con el CRM.
        </p>
      </div>

      <div className='calendar-integration-grid'>
        <div className='calendar-integration-item'>
          <h3>Disponibilidad</h3>
          <p>Consultamos los horarios disponibles para ayudar a coordinar citas sin salir de Lancaster.</p>
        </div>

        <div className='calendar-integration-item'>
          <h3>Administración de citas</h3>
          <p>Creamos, actualizamos o cancelamos eventos cuando una cita se gestiona desde la plataforma.</p>
        </div>

        <div className='calendar-integration-item'>
          <h3>Control del usuario</h3>
          <p>La conexión es opcional, puede desconectarse desde el perfil y no usamos datos del calendario para publicidad.</p>
        </div>
      </div>

      <div className='calendar-integration-links'>
        <a href='/politica-privacidad'>Política de Privacidad</a>
        <a href='/terminos-condiciones'>Términos y Condiciones</a>
      </div>
    </section>
  );
};

export default CalendarIntegration;
